import { observer } from "mobx-react";
import React from "react";
import { generalConfigurationStore as store } from "../Stores/GeneralConfigurationStore";
import { Link } from "react-router-dom";
import utilsFunctions from "../Utils/ModuleHelpers";
import "./SummaryCustomerInformation.css";


@observer
class SummaryCustomerInformation extends React.Component {


	render() {
		const textInputs = store.productConfigurationStore?.selection.textNotes || {};
		const getAnchor = utilsFunctions.getAnchor(store.configs?.cultivationTypeHeadline);

		return (
			<div className="col-12 col-lg-11 summary-customer-information">
				<div className="summary-entity-header">
					<h3 className="summary-entity-headline">{store.configs?.cultivationTypeHeadline}</h3>
					<Link className="btn btn-simple" to={"/#" + getAnchor}>
						{store.configs?.generalChangeText}
					</Link>
				</div>
				<div className="summary-ci-list-wrapper">
					<div>
						<div className="list-item">
							<h4 className="module-title">{store.configs?.cultivationTypeSubheadlineFrontBack}</h4>
							<p>{store.productConfigurationStore?.selection.deliverType?.name}</p>
						</div>
					</div>
					
					{Object.keys(textInputs).map((tInput, index) => {
						return (
							<div key={`${index}-single-text-input`}>
								{tInput === "customerAnnotation" && textInputs[tInput].length > 0 && (
									<div className="list-item">
										<h4 className="module-title">{store.configs?.cultivationTypeSubheadlineNote}</h4>
										<p>{textInputs[tInput]}</p>
									</div>
								)}
							</div>
						);
					})}
				</div>
			</div>
		);
	}
}

export default SummaryCustomerInformation;
